import { createFileRoute, Link } from "@tanstack/react-router";
import { MapPin } from "lucide-react";
import { Reveal } from "@/components/site-chrome";
import { PageHero, Eyebrow, HoursCard, FinalCta } from "@/components/sections";
import { towns, townNotes } from "@/lib/site-data";
import { pageHead, breadcrumbLd } from "@/lib/seo";

const TITLE = "Service Area: Great Falls & Montana | 406 Mobile Mechanic";
const DESC = "406 Mobile Mechanic serves Great Falls, Black Eagle, Malmstrom AFB, Vaughn, Belt, Cascade, Ulm, Sun River, Dutton, Fort Benton and statewide. Call or text 406-799-0095.";

export const Route = createFileRoute("/service-area")({
  head: () => pageHead("/service-area", TITLE, DESC, [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Service Area", path: "/service-area" }])]),
  component: AreaPage,
});

function AreaPage() {
  return (
    <main>
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "Service Area" }]}
        title={<>Mobile Mechanic Serving <span className="text-primary">Great Falls & Across Montana</span></>}
        intro="Based in Great Falls, MT, with regular trips to surrounding towns and statewide travel available. Call or text with your location and Josh will tell you straight what's possible."
        photo="hero"
      />
      <section className="bg-background py-24" aria-labelledby="towns-h">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Eyebrow>Towns we serve</Eyebrow>
          <h2 id="towns-h" className="mt-4 text-4xl font-black md:text-5xl">Where We Work</h2>
          <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {towns.map((t) => (
              <Reveal as="li" key={t} className="rounded-sm border border-border bg-card p-6">
                <p className="flex items-center gap-2 font-display text-2xl font-extrabold uppercase"><MapPin className="h-5 w-5 text-primary" aria-hidden />{t}</p>
                <p className="mt-2 text-sm text-muted-foreground">{townNotes[t]}</p>
              </Reveal>
            ))}
            <Reveal as="li" className="rounded-sm border-2 border-primary bg-card p-6">
              <p className="font-display text-2xl font-extrabold uppercase text-primary">Statewide travel available</p>
              <p className="mt-2 text-sm text-muted-foreground">Farther out in Montana? Call or text to plan the trip.</p>
            </Reveal>
          </ul>
        </div>
      </section>
      <section className="topo bg-charcoal-deep py-24" aria-labelledby="map-h">
        <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[1.4fr_1fr] lg:items-center">
          <div>
            <h2 id="map-h" className="text-4xl font-black md:text-5xl">Based in Great Falls, MT</h2>
            <iframe
              title="Map of Great Falls, Montana"
              src="https://www.google.com/maps?q=Great+Falls,+MT&z=10&output=embed"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="mt-8 aspect-[4/3] w-full rounded-sm border-2 border-border"
            />
            <p className="mt-4 text-sm text-muted-foreground">Need help where you are? <Link to="/contact" className="text-primary hover:underline">Contact Josh</Link> or browse <Link to="/services" className="text-primary hover:underline">services</Link>.</p>
          </div>
          <HoursCard />
        </div>
      </section>
      <FinalCta />
    </main>
  );
}
